import { render, staticRenderFns } from "./bigScreenDictList.vue?vue&type=template&id=5267055e&scoped=true&"
import script from "./bigScreenDictList.vue?vue&type=script&lang=js&"
export * from "./bigScreenDictList.vue?vue&type=script&lang=js&"
import style0 from "./bigScreenDictList.vue?vue&type=style&index=0&id=5267055e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5267055e",
  null
  
)

export default component.exports